<fury-page-layout mode="card">
    <fury-page-layout-header>
        <fury-breadcrumbs [@fadeInRight]  current="Statistics Review"></fury-breadcrumbs>
    </fury-page-layout-header>
    <fury-page-layout-content [@fadeInUp]>
        <div fxLayout="column" fxLayoutAlign="start center">
            <div [@fadeInUp] class="card">
                <div class="reviewdetail">
                    <h2>Statistics Review</h2>
                    <div *ngIf="!loading">
                        <!-- summary section -->
                        <div class="feedbacklist">
                            <h3>Summary</h3>
                            <div class="chartprt">
                                <div class="leftchart">
                                    <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels" [chartType]="doughnutChartType"
                [plugins]="doughnutChartPlugins" (chartHover)="chartHovered($event)"
                (chartClick)="chartClicked($event)"></canvas>
                                </div>
                                <div class="rightchart">
                                    <ul>
                                        <li>Awful: <span>{{statisticsReviewData?.summary['awful']}}</span></li>
                                        <li>Poor: <span>{{statisticsReviewData?.summary['poor']}}</span></li>
                                        <li>Fair: <span>{{statisticsReviewData?.summary['fair']}}</span></li>
                                        <li>Good: <span>{{statisticsReviewData?.summary['good']}}</span></li>
                                        <li>Great: <span>{{statisticsReviewData?.summary['great']}}</span></li>
                                    </ul>
                                </div>
                            </div>
                            
                        </div>
                        <!-- Url summary section -->
                        <div class="feedbacklist" style="margin-top: 30px;">
                            <h3>Url summary</h3>
                            <div class="urlList">
                                <ul>
                                    <li>
                                        <b>BBB</b>
                                        <div class="bar">
                                            <span [ngStyle]="{ 'width' : statisticsReviewData?.urlSummary['bbb']?.percentage + '%'}"></span>
                                        </div>
                                        <p>{{statisticsReviewData?.urlSummary['bbb']?.percentage + '%'}} (clicks: {{statisticsReviewData?.urlSummary['bbb']?.clicks}})</p>
                                    </li>
                                    <li>
                                        <b>Google</b>
                                        <div class="bar">
                                            <span [ngStyle]="{ 'width' : statisticsReviewData?.urlSummary['google']?.percentage + '%'}"></span>
                                        </div>
                                        <p>{{statisticsReviewData?.urlSummary['google']?.percentage + '%'}} (clicks: {{statisticsReviewData?.urlSummary['google']?.clicks}})</p>
                                    </li>
                                   <li>
                                        <b>Best Company</b>
                                        <div class="bar">
                                            <span [ngStyle]="{ 'width' : statisticsReviewData?.urlSummary['bestCompany']?.percentage + '%'}"></span>
                                        </div>
                                        <p>
                                            {{statisticsReviewData?.urlSummary['bestCompany']?.percentage + '%'}}  (clicks: {{statisticsReviewData?.urlSummary['bestCompany']?.clicks}})
                                        </p>
                                    </li>
                                    <li>
                                        <b>Consumer Affairs</b>
                                        <div class="bar">
                                            <span [ngStyle]="{ 'width' : statisticsReviewData?.urlSummary['consumerAffairs']?.percentage + '%'}"></span>
                                        </div>
                                        <p>
                                            {{statisticsReviewData?.urlSummary['consumerAffairs']?.percentage + '%'}} (clicks: {{statisticsReviewData?.urlSummary['consumerAffairs']?.clicks}})
                                        </p>
                                    </li>
                                    <li>
                                        <b>Consumers Advocate</b>
                                        <div class="bar">
                                            <span [ngStyle]="{ 'width' : statisticsReviewData?.urlSummary['consumersAdvocate']?.percentage + '%'}"></span>
                                        </div>
                                        <p>
                                            {{statisticsReviewData?.urlSummary['consumersAdvocate']?.percentage + '%'}} (clicks: {{statisticsReviewData?.urlSummary['consumersAdvocate']?.clicks}})
                                        </p>
                                    </li>
                                    <li>
                                        <b>Home Advisor</b>
                                        <div class="bar">
                                            <span [ngStyle]="{ 'width' : statisticsReviewData?.urlSummary['homeAdvisor']?.percentage + '%'}"></span>
                                        </div>
                                        <p>
                                            {{statisticsReviewData?.urlSummary['homeAdvisor']?.percentage + '%'}} (clicks: {{statisticsReviewData?.urlSummary['homeAdvisor']?.clicks}})
                                        </p>
                                    </li>
                                    <li>
                                        <b>Home Warranty Reviews</b>
                                        <div class="bar">
                                            <span [ngStyle]="{ 'width' : statisticsReviewData?.urlSummary['homeWarrantyReviews']?.percentage + '%'}"></span>
                                        </div>
                                        <p>
                                            {{statisticsReviewData?.urlSummary['homeWarrantyReviews']?.percentage + '%'}} (clicks: {{statisticsReviewData?.urlSummary['homeWarrantyReviews']?.clicks}})
                                        </p>
                                    </li>
                                    <li>
                                        <b>Retirement Living</b>
                                        <div class="bar">
                                            <span [ngStyle]="{ 'width' : statisticsReviewData?.urlSummary['retirementLiving']?.percentage + '%'}"></span>
                                        </div>
                                        <p>
                                            {{statisticsReviewData?.urlSummary['retirementLiving']?.percentage + '%'}} (clicks: {{statisticsReviewData?.urlSummary['retirementLiving']?.clicks}})
                                        </p>
                                    </li>
                                    <li>
                                        <b>Trust Pilot</b>
                                        <div class="bar">
                                            <span [ngStyle]="{ 'width' : statisticsReviewData?.urlSummary['trustPilot']?.percentage + '%'}"></span>
                                        </div>
                                        <p>
                                            {{statisticsReviewData?.urlSummary['trustPilot']?.percentage + '%'}} (clicks: {{statisticsReviewData?.urlSummary['trustPilot']?.clicks}})
                                        </p>
                                    </li>
                                    <li>
                                        <b>Yelp</b>
                                        <div class="bar">
                                            <span [ngStyle]="{ 'width' : statisticsReviewData?.urlSummary['yelp']?.percentage + '%'}"></span>
                                        </div>
                                        <p>
                                            {{statisticsReviewData?.urlSummary['yelp']?.percentage + '%'}} (clicks: {{statisticsReviewData?.urlSummary['yelp']?.clicks}})
                                        </p>
                                    </li> 
                                </ul>
                            </div>
                        </div>
                        <!-- details sections -->
                        <div style="margin-top: 30px;">
                            <h3 style="font-size: 1.5rem; font-weight: bold;">Details</h3>
                            <div class="fullbox">
                                <div class="detailbox" *ngFor="let item of statisticsReviewData?.details">
                               
                                    <div class="innerboxprt">
                                        <span class="ipprt">{{item?.ipAddress}}</span>
                                        <div class="rightvalueprt">
                                            <span>Great ({{item?.great}})</span>
                                            <span>Good ({{item?.good}})</span>
                                            <span>Fair ({{item?.fair}})</span>
                                            <span>Poor ({{item?.poor}})</span>
                                            <span>Awful ({{item?.awful}})</span>
                                            <span>Total ({{item?.total}})</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="loadprt" style="text-align: center;" *ngIf="size < totalCount">
                                <button *ngIf="!loadingMoreDetails" mat-raised-button class="black" (click)="loadMoreDetails()">Load More</button>
                                <p *ngIf="loadingMoreDetails">Please Wait..</p>
                            </div>
                            <span id="bottomPosition"></span>
                        </div>
                    </div>
                    <div *ngIf="loading">Please Wait..</div>
                </div>
            </div>
          </div>
    </fury-page-layout-content>
</fury-page-layout>






  
  


